/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCharactersCharacterIdMailMailIdRecipient } from './GetCharactersCharacterIdMailMailIdRecipient';
import {
    GetCharactersCharacterIdMailMailIdRecipientFromJSON,
    GetCharactersCharacterIdMailMailIdRecipientFromJSONTyped,
    GetCharactersCharacterIdMailMailIdRecipientToJSON,
    GetCharactersCharacterIdMailMailIdRecipientToJSONTyped,
} from './GetCharactersCharacterIdMailMailIdRecipient';

/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdMailMailIdOk
 */
export interface GetCharactersCharacterIdMailMailIdOk {
    /**
     * Mail's body
     * @type {string}
     * @memberof GetCharactersCharacterIdMailMailIdOk
     */
    body?: string;
    /**
     * From whom the mail was sent
     * @type {number}
     * @memberof GetCharactersCharacterIdMailMailIdOk
     */
    from?: number;
    /**
     * Labels attached to the mail
     * @type {Array<number>}
     * @memberof GetCharactersCharacterIdMailMailIdOk
     */
    labels?: Array<number>;
    /**
     * Whether the mail is flagged as read
     * @type {boolean}
     * @memberof GetCharactersCharacterIdMailMailIdOk
     */
    read?: boolean;
    /**
     * Recipients of the mail
     * @type {Set<GetCharactersCharacterIdMailMailIdRecipient>}
     * @memberof GetCharactersCharacterIdMailMailIdOk
     */
    recipients?: Set<GetCharactersCharacterIdMailMailIdRecipient>;
    /**
     * Mail subject
     * @type {string}
     * @memberof GetCharactersCharacterIdMailMailIdOk
     */
    subject?: string;
    /**
     * When the mail was sent
     * @type {Date}
     * @memberof GetCharactersCharacterIdMailMailIdOk
     */
    timestamp?: Date;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdMailMailIdOk interface.
 */
export function instanceOfGetCharactersCharacterIdMailMailIdOk(value: object): value is GetCharactersCharacterIdMailMailIdOk {
    return true;
}

export function GetCharactersCharacterIdMailMailIdOkFromJSON(json: any): GetCharactersCharacterIdMailMailIdOk {
    return GetCharactersCharacterIdMailMailIdOkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdMailMailIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdMailMailIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'] == null ? undefined : json['body'],
        'from': json['from'] == null ? undefined : json['from'],
        'labels': json['labels'] == null ? undefined : json['labels'],
        'read': json['read'] == null ? undefined : json['read'],
        'recipients': json['recipients'] == null ? undefined : (new Set((json['recipients'] as Array<any>).map(GetCharactersCharacterIdMailMailIdRecipientFromJSON))),
        'subject': json['subject'] == null ? undefined : json['subject'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
    };
}

export function GetCharactersCharacterIdMailMailIdOkToJSON(json: any): GetCharactersCharacterIdMailMailIdOk {
    return GetCharactersCharacterIdMailMailIdOkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdMailMailIdOkToJSONTyped(value?: GetCharactersCharacterIdMailMailIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
        'from': value['from'],
        'labels': value['labels'],
        'read': value['read'],
        'recipients': value['recipients'] == null ? undefined : (Array.from(value['recipients'] as Set<any>).map(GetCharactersCharacterIdMailMailIdRecipientToJSON)),
        'subject': value['subject'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
    };
}

